import type { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import type { UsedSource } from "@noa/api-core";
import { buildDocumentUrl } from "../../utils/document-url.utils";
import { getFileExtension } from "@noa/ui";
import { FileTypeIcon } from "./file-type-icon";
import { ReferenceDocPopover } from "./reference-document-popover";
import { Card, Text } from "~/components/ui";

interface ReferenceDocumentCardProps {
  document: UsedSource;
  textReferenceIndex: number;
}

export const ReferenceDocumentCard: FunctionComponent<ReferenceDocumentCardProps> = ({
  document,
  textReferenceIndex,
}) => {
  const { t } = useTranslation();

  const { source_document_name, location_information, source_url } = document;
  const href = buildDocumentUrl(source_url, location_information, source_document_name) || `#${textReferenceIndex}`;

  const fileExtension = getFileExtension(source_document_name);
  const fileTypeDescription = t(`referenceDocs:fileType.${fileExtension}`, {
    defaultValue: t("referenceDocs:fileType.default"),
  });

  return (
    <ReferenceDocPopover href={href}>
      <Card className="mb-3 cursor-pointer" hoverable bodyClassName="p-[18px]">
        <div className="flex gap-3">
          <div className="flex shrink-0">
            <FileTypeIcon fileType={fileExtension} />
          </div>

          <div className="flex flex-col">
            <Text strong>{source_document_name}</Text>

            <div className="flex flex-col">
              <Text tone="muted" className="text-xs">
                {location_information}
              </Text>

              <Text tone="muted" className="text-xs">
                {`Ref.[${textReferenceIndex}]`} {fileTypeDescription}
              </Text>
            </div>
          </div>
        </div>
      </Card>
    </ReferenceDocPopover>
  );
};
